import * as React from 'react'
import { LogPointStates } from '../../../util/LogPointsService'
import { filterConfiguration, LogPointCategory, LogPointType } from '../../../util/LoggingPolicyConfigurations'
import { LogPointsConfigurationItem } from './LogPointsConfigurationItem'
import ListPanel from '@mulesoft/anypoint-components/lib/List'
import './LogPointsConfiguration.css'

export type ValueProps = {
  state: LogPointStates
  logPointType: LogPointType
  logPointCategory: LogPointCategory
}

export type EventProps = {
  onLogPointActivate: (id: string) => void
  onToggleAll: (toggleNewVal: boolean) => void
}

export type Props = ValueProps & EventProps

const getConfigurationItems = ({state, onLogPointActivate}: Props, keys: string[]): JSX.Element[] => {
  return keys.map((key, index) => {
    const onPointActivate = () => onLogPointActivate(key)

    return (
      <LogPointsConfigurationItem
        key={index + 1}
        itemKey={key}
        label={state[key].label}
        enabled={state[key].enabled}
        onLogPointActivate={onPointActivate}
      />
    )
  })
}

const getConfigurationItemHeader = () => (
  <div key={0} className="log-points-configuration-item-header" data-test-id="log-points-configuration-item-header">
    <span className="log-points-configuration-item-header-title" data-test-id="log-points-configuration-item-header-title">Properties</span>
  </div>
)

export const LogPointsConfiguration = (props: Props) => {
  const {state, logPointCategory, logPointType} = props
  const keys = Object.keys(props.state).filter(filterConfiguration(state, logPointCategory, logPointType))
  const items = [getConfigurationItemHeader(), ...getConfigurationItems(props, keys)]

  return (
    <div className="log-points-configuration-container" data-test-id="log-points-configuration-container">
      <div className="log-points-configuration-notes">
        <span className="log-points-configuration-note" data-test-id="log-points-configuration-note">
        Disable the Log Points when you are done, as it may affect your API's performance.
        </span>

        {
          logPointCategory === LogPointCategory.Body &&
          <span className="log-points-configuration-note" data-test-id="log-points-configuration-note-body">
          <span>Note: </span>
            If the body is used as part of the message log, do not configure the Listener as non-repeatable (by default this setting is off).
          </span>
        }
      </div>
      <div className="log-points-configuration" data-test-id="log-points-configuration">
        <ListPanel items={items}/>
      </div>
    </div>
  )
}
